import { createApiAction } from 'src/api';

export const FETCH_LICENSES_START = 'license/fetch_licenses_start';
export const FETCH_LICENSES_SUCCESS = 'license/fetch_licenses_success';
export const FETCH_LICENSES_FAILURE = 'license/fetch_licenses_failure';

export const SUBMIT_LICENSES_START = 'license/submit_licenses_start';
export const SUBMIT_LICENSES_SUCCESS = 'license/submit_licenses_success';
export const SUBMIT_LICENSES_FAILURE = 'license/submit_licenses_failure';

export const UPDATE_LICENSES_START = 'license/update_licenses_start';
export const UPDATE_LICENSES_SUCCESS = 'license/update_licenses_success';
export const UPDATE_LICENSES_FAILURE = 'license/update_licenses_failure';

export const fetchLicenses = () =>
  createApiAction(
    {
      path: `/api/v1/accounts/locations/licenses`,
      method: 'GET',
    },
    [FETCH_LICENSES_START, FETCH_LICENSES_SUCCESS, FETCH_LICENSES_FAILURE]
  );

export const submitLicenses = ({ licenseIds }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/locations/licenses`,
      method: 'POST',
      body: {
        license_ids: licenseIds,
      },
    },
    [SUBMIT_LICENSES_START, SUBMIT_LICENSES_SUCCESS, SUBMIT_LICENSES_FAILURE]
  );

export const updateLicense = ({ id, licenseLink, consentLink }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/locations/licenses`,
      method: 'PUT',
      body: {
        location_license_url: licenseLink,
        location_consent_url: consentLink,
        id,
      },
    },
    [UPDATE_LICENSES_START, UPDATE_LICENSES_SUCCESS, UPDATE_LICENSES_FAILURE]
  );
